import { t } from 'ttag'
import { useMutation, useQueryClient } from 'react-query'

import { useForm } from '@h2/common/components/hooks/useForm'
import { TextInput } from '@h2/components/inputs/text'
import { Button } from '@h2/components/buttons/button'
import { api, errors } from '@h2/api'
import { Field } from '@h2/components/inputs/field'
import { Flex } from '@h2/components/layout/flex'

const RenameBudgetForm = ({ budgetId, budgetName, cancelEdit }) => {
  const { register, error, isInvalid, dispatch, handleOnSubmit } = useForm({
    initialValues: {
      name: budgetName
    },
    name(form) {
      if (!form.name?.trim()) {
        return t`A valid name is required`
      }
    }
  })
  const queryClient = useQueryClient()
  const { mutate, isLoading } = useMutation(
    ({ name }) =>
      api.fetch(`/budget/${budgetId}`, {
        method: 'PUT',
        body: JSON.stringify({ name })
      }),
    {
      onSuccess: async newBudget => {
        await queryClient.setQueryData(['budget-listing'], queryData => {
          return {
            ...queryData,
            budgets: queryData.budgets.map(rec => (rec.id === budgetId ? newBudget : rec))
          }
        })
        cancelEdit()
      },
      onError: err => {
        const formErrors = errors.getValidation(err)

        if (formErrors) {
          dispatch({ type: 'validate', payload: formErrors })
        }
      }
    }
  )

  return (
    <form onSubmit={handleOnSubmit(form => mutate(form))}>
      <Flex gap="10px" alignItems="flex-end">
        <Field
          isRequired
          label={t`Budget Name`}
          desc={error.name}
          status={error.name ? 'error' : 'default'}>
          <TextInput {...register('name')} />
        </Field>
        <div>
          <Button type="submit" isLoading={isLoading} isDisabled={isLoading || isInvalid}>
            {t`Rename`}
          </Button>
          <Button type="button" display="red" onClick={cancelEdit}>
            {t`Cancel`}
          </Button>
        </div>
      </Flex>
    </form>
  )
}

export { RenameBudgetForm }
